var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#BFDAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 5.81641L9.10938 6.33594C9 6.47266 9 6.69141 9.10938 6.80078L14.0586 11.75L9.10938 16.7266C9 16.8359 9 17.0547 9.10938 17.1914L9.65625 17.7109C9.79297 17.8477 9.98438 17.8477 10.1211 17.7109L15.8633 11.9961C15.9727 11.8594 15.9727 11.668 15.8633 11.5312L10.1211 5.81641C9.98438 5.67969 9.79297 5.67969 9.65625 5.81641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.42067e52f5040f9aebc7fe8c1f231dd2.svg";
export { ForwardRef as ReactComponent };